import React from "react";
import ReactLoading from "react-loading";

const LoadingComponent = () => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <ReactLoading className="animate-spin rounded-full h-14 w-14 border-b-2 border-orange-600 mx-auto" />
    </div>
  );
};

export default LoadingComponent;